<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer>
                <template slot="list">
                    <SettingsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <SettingsUsersEditContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>